import { createSlice } from "@reduxjs/toolkit";
import {
  createConsultation,
  getConsultationById,
  getConsultationsByPatient,
  getConsultationsByDoctor,
  updateConsultation,
  deleteConsultation,
} from "../thunks/consultationThunks";

const initialState = {
  selectedConsultation: null,
  patientConsultations: [],
  doctorConsultations: [],
  loading: false,
  error: null,
  success: false,
};

const consultationSlice = createSlice({
  name: "consultation",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    resetSelectedConsultation: (state) => {
      state.selectedConsultation = null;
    },
  },
  extraReducers: (builder) => {
    /* ===== CREATE ===== */
    builder
      .addCase(createConsultation.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createConsultation.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.selectedConsultation = action.payload;

        const createdConsultation =
          action.payload?.data || action.payload;

        if (createdConsultation?.id || createdConsultation?._id) {
          const createdId = String(
            createdConsultation.id || createdConsultation._id
          );

          state.patientConsultations = [
            createdConsultation,
            ...state.patientConsultations.filter(
              (consultation) =>
                String(consultation?.id || consultation?._id) !== createdId
            ),
          ];
        }
      })
      .addCase(createConsultation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    /* ===== GET BY ID ===== */
    builder
      .addCase(getConsultationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getConsultationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedConsultation = action.payload;
      })
      .addCase(getConsultationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    /* ===== BY PATIENT ===== */
    builder
      .addCase(getConsultationsByPatient.pending, (state) => {
        state.loading = true;
      })
      .addCase(getConsultationsByPatient.fulfilled, (state, action) => {
        state.loading = false;
        state.patientConsultations = action.payload;
      })
      .addCase(getConsultationsByPatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    /* ===== BY DOCTOR ===== */
    builder
      .addCase(getConsultationsByDoctor.pending, (state) => {
        state.loading = true;
      })
      .addCase(getConsultationsByDoctor.fulfilled, (state, action) => {
        state.loading = false;
        state.doctorConsultations = action.payload;
      })
      .addCase(getConsultationsByDoctor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    /* ===== UPDATE ===== */
    builder
      .addCase(updateConsultation.fulfilled, (state, action) => {
        state.success = true;
        state.selectedConsultation = action.payload;
      });

    /* ===== DELETE ===== */
    builder
      .addCase(deleteConsultation.fulfilled, (state, action) => {
        state.success = true;
        state.selectedConsultation = null;
        state.patientConsultations = state.patientConsultations.filter(
          (c) => c.id !== action.payload
        );
        state.doctorConsultations = state.doctorConsultations.filter(
          (c) => c.id !== action.payload
        );
      });
  },
});

export const {
  clearError,
  clearSuccess,
  resetSelectedConsultation,
} = consultationSlice.actions;

export default consultationSlice.reducer;
